import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import './LoanHistory.css';
import { ProfilePreviewWrapper } from "../Dashboard/ProfilePage/style";
import ProfileHeader from "../Dashboard/ProfilePage/ProfileHeader";
import { loanDetail } from "../../Utils/api";

function LoanDetail() {
  const location = useLocation();
  const { leadId } = location.state || {};
  const [loan, setLoan] = useState(null);
  const [collection, setCollection] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = {
      lead_id: leadId,
    };

    loanDetail(params).then(resp => {
      if (resp?.data?.Status === 1) {
        // setStorage("eligibility",resp?.data?.Data?.registration_successful)
        const loanData = resp?.data?.data[0] || {};
        const collectionData = resp?.data?.collection[0] || {};
        setLoan(loanData);
        setCollection(collectionData);
      }
    });
  }, []);

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error}</div>;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  return (
    <ProfilePreviewWrapper>
      <ProfileHeader />
      <div className="flex w-full justify-center my-[35px]">
        <div className="loan-history-card  w-full">
          {loan ? (
            <>
              <h2 className="text-2xl font-bold text-blue-700 mb-6">
                Loan Details
              </h2>

              <div className="grid md:grid-cols-2 gap-4">

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Loan Number</span>
                  <span className="font-semibold text-blue-900">{loan.loan_no}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Customer Name</span>
                  <span className="font-semibold text-blue-900">{loan.first_name}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Monthly Salary</span>
                  <span className="font-semibold text-blue-900">
                    ₹{loan.monthly_salary_amount}
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Loan Amount</span>
                  <span className="font-semibold text-blue-900">
                    ₹{loan.loan_recommended}
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Tenure</span>
                  <span className="font-semibold text-blue-900">
                    {loan.tenure} Months
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Purpose</span>
                  <span className="font-semibold text-blue-900">{loan.purpose}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Mobile</span>
                  <span className="font-semibold text-blue-900">{loan.mobile}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Email</span>
                  <span className="font-semibold text-blue-900 break-all">
                    {loan.email}
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Application Status</span>
                  <span className="font-semibold text-green-600">{loan.status}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">PAN Card</span>
                  <span className="font-semibold text-blue-900">{loan.pancard}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Current City</span>
                  <span className="font-semibold text-blue-900">{loan.m_city_name}</span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="font-medium text-gray-600">Current State</span>
                  <span className="font-semibold text-blue-900">{loan.m_state_name}</span>
                </div>

                <div className="flex justify-between border-b pb-2 md:col-span-2">
                  <span className="font-medium text-gray-600">Loan Date</span>
                  <span className="font-semibold text-blue-900">
                    {loan.lead_final_disbursed_date}
                  </span>
                </div>

              </div>
            </>
          ) : (
            <p className="text-center text-gray-500">
              No loan details available.
            </p>
          )}
        </div>
      </div>





















      {/* <br/>
            <h2>Payment History</h2>
            <div className="collection-container">
              {collection.length > 0 ? (
                collection.map((item, index) => (
                  <div key={index} className="collection-card">
                    <p><strong>Received Amount:</strong> {item.received_amount}</p>
                    <p><strong>Date of Received:</strong> {formatDate(item.date_of_recived)}</p>
                    <p><strong>Remarks:</strong> {item.remarks}</p>
                  </div>
                ))
              ) : (
                <p>No Payment History available.</p>
              )}
            </div> */}
      {/* </>
          ) : (
            <p>No loan details available.</p>
          )}
        </div>
      </div> */}
    </ProfilePreviewWrapper>
  );
}

export default LoanDetail;